import script from "./canvasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./canvasComponent.vue?vue&type=script&setup=true&lang=js"

import "./canvasComponent.vue?vue&type=style&index=0&id=434bbf87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434bbf87"]])

export default __exports__